const countryNorwayOnly: { [key: string]: string } = {
  NO: 'Norway',
};

export default countryNorwayOnly;
